// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"Snackbar_snackbar__2NrkX"};